/* eslint-disable sort-keys */
export const urls: Record<
  'fr',
  Record<string, '/l/fr/fr' | `/l/fr/fr/${string}`>
> = {
  fr: {
    // Home
    '': '/l/fr/fr/home',

    // Alumni
    alumni: '/l/fr/fr/alumni',

    // Apprenticeships
    'alternance/developpement-web': '/l/fr/fr/apprenticeship/wd',
    'alternance/data-analytics': '/l/fr/fr/apprenticeship/da',
    'alternance/ux-ui-design': '/l/fr/fr/apprenticeship/ux',
    'alternance/cybersecurite': '/l/fr/fr/apprenticeship/cy',
    'alternance/devops-cloud-computing': '/l/fr/fr/apprenticeship/dv',

    // B2B
    entreprise: '/l/fr/fr/b2b',
    'entreprise/contact': '/l/fr/fr/b2b/apply',

    // Blog
    blog: '/l/fr/fr/blog',

    // Campus
    paris: '/l/fr/fr/campus/par',
    'a-distance': '/l/fr/fr/campus/rmt',

    // Career
    'soutien-professionnel': '/l/fr/fr/career',

    // Courses
    'developpement-web': '/l/fr/fr/course/wd',
    'data-analytics': '/l/fr/fr/course/da',
    'ux-ui-design': '/l/fr/fr/course/ux',
    cybersecurite: '/l/fr/fr/course/cy',

    // FAQ
    faq: '/l/fr/fr/faq',

    // Financing Options
    'option-de-financement': '/l/fr/fr/financing',

    // Forms
    inscription: '/l/fr/fr/apply',
    inscription2: '/l/fr/fr/full-apply',
    contact: '/l/fr/fr/contact',
    'formulaire-de-financement': '/l/fr/fr/financing-form',
    merci: '/l/fr/fr/thank-you',

    // Quiz
    quiz: '/l/fr/fr/quiz',
    'intelligence-artificielle/match': '/l/fr/fr/quiz-match/ai',
    'cybersecurite/match': '/l/fr/fr/quiz-match/cy',
    'data-analytics/match': '/l/fr/fr/quiz-match/da',
    'devops-cloud-computing/match': '/l/fr/fr/quiz-match/dv',
    'marketing-digital/match': '/l/fr/fr/quiz-match/mk',
    'data-science-machine-learning/match': '/l/fr/fr/quiz-match/ml',
    'ux-ui-design/match': '/l/fr/fr/quiz-match/ux',
    'developpement-web/match': '/l/fr/fr/quiz-match/wd',

    // Syllabus Forms
    'consulting-ia/syllabus': '/l/fr/fr/syllabus/ac',
    'intelligence-artificielle/syllabus': '/l/fr/fr/syllabus/ai',
    'ingenieur-cloud/syllabus': '/l/fr/fr/syllabus/ce',
    'cybersecurite/syllabus': '/l/fr/fr/syllabus/cy',
    'data-analytics/syllabus': '/l/fr/fr/syllabus/da',
    'data-engineer/syllabus': '/l/fr/fr/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/fr/fr/syllabus/dv',
    'marketing-digital/syllabus': '/l/fr/fr/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/fr/fr/syllabus/ml',
    'product-manager-ia/syllabus': '/l/fr/fr/syllabus/pm',
    'ux-ui-design/syllabus': '/l/fr/fr/syllabus/ux',
    'developpement-web/syllabus': '/l/fr/fr/syllabus/wd',

    // PDP
    'consulting-ia/a-distance': '/l/fr/fr/pdp/ac/rmt',
    'intelligence-artificielle/a-distance': '/l/fr/fr/pdp/ai/rmt',
    'ingenieur-cloud/a-distance': '/l/fr/fr/pdp/ce/rmt',
    'cybersecurite/paris': '/l/fr/fr/pdp/cy/par',
    'cybersecurite/a-distance': '/l/fr/fr/pdp/cy/rmt',
    'data-analytics/paris': '/l/fr/fr/pdp/da/par',
    'data-analytics/a-distance': '/l/fr/fr/pdp/da/rmt',
    'data-engineer/a-distance': '/l/fr/fr/pdp/de/rmt',
    'devops-cloud-computing/a-distance': '/l/fr/fr/pdp/dv/rmt',
    'marketing-digital/a-distance': '/l/fr/fr/pdp/mk/rmt',
    'data-science-machine-learning/a-distance': '/l/fr/fr/pdp/ml/rmt',
    'product-manager-ia/a-distance': '/l/fr/fr/pdp/pm/rmt',
    'ux-ui-design/paris': '/l/fr/fr/pdp/ux/par',
    'ux-ui-design/a-distance': '/l/fr/fr/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
